import { Action, Reducer } from 'redux';
import { PackageState, PackageTypes, PackageActionTypes } from './packageTypes';

export const INITIAL_STATE: PackageState = {
  package: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  }
};

const packageReducer: Reducer<PackageState> = (
  state: PackageState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as PackageActionTypes;
  switch (actionTypes.type) {
    case PackageTypes.GET_PACKAGE:
      return {
        ...state,
        package: { ...state.package, isLoading: true }
      };
    case PackageTypes.SAVE_PACKAGE:
      return {
        ...state,
        package: {
          ...state.package,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case PackageTypes.RESET_REDUCER_PACKAGE:
      return {
        ...state,
        package: INITIAL_STATE.package
      };
    default:
      return state;
  }
};

export default packageReducer;

